export default __webpack_public_path__ + "static/media/pfpblequity.805beb01.webp";